import React, { Component } from 'react'
import Helmet from 'react-helmet'
import PropTypes from 'prop-types'
import styled from 'styled-components'

// Utilities
import kebabCase from 'lodash/kebabCase'
import startCase from 'lodash/startCase'

// Components
import Link, { navigateTo } from 'gatsby-link'
import Img from 'gatsby-image'
import Slider from '../components/Slider'
import NavContainer from '../components/Nav'

const DisciplineContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`

class Discipline extends Component {
  constructor(props) {
    super(props)

    this.state = {
      current: 1,
    }
  }

  setURL(current) {
    const { pathname } = this.props.location
    const url = `${pathname}?slide=${current}`

    this.setState({ current: current })
    navigateTo(url)
  }

  componentWillMount() {
    const { pathname, search } = this.props.location
    const getParam = /(\d+)(?!.*\d)/

    const current = search !== '' ? Number(search.match(getParam)[0]) : 0
    this.setState({ current: current })
  }

  componentDidMount() {
    console.clear()
  }

  render() {
    const { discipline, disciplines } = this.props.pathContext
    const { edges, totalCount } = this.props.data.allMarkdownRemark

    return (
      <div>
        <Helmet title={`${startCase(discipline)}`} />

        <DisciplineContainer>
          <Slider
            data={edges}
            current={this.state.current}
            onChange={this.setURL.bind(this)}
          />
        </DisciplineContainer>

        <NavContainer>
          {disciplines.map(discipline => (
            <Link
              key={discipline}
              activeClassName="active"
              to={`/discipline/${kebabCase(discipline)}/`}
            >
              {discipline}
            </Link>
          ))}
        </NavContainer>
      </div>
    )
  }
}

Discipline.propTypes = {
  pathContext: PropTypes.shape({
    discipline: PropTypes.string.isRequired,
  }),
  data: PropTypes.shape({
    allMarkdownRemark: PropTypes.shape({
      totalCount: PropTypes.number.isRequired,
      edges: PropTypes.arrayOf(
        PropTypes.shape({
          node: PropTypes.shape({
            frontmatter: PropTypes.shape({
              title: PropTypes.string.isRequired,
              cover: PropTypes.object.isRequired,
            }),
          }),
        }).isRequired
      ),
    }),
  }),
}

export default Discipline

export const pageQuery = graphql`
  query DisciplinePage($discipline: String) {
    allMarkdownRemark(
      limit: 2000
      sort: { fields: [frontmatter___order], order: DESC }
      filter: {
        frontmatter: {
          disciplines: { in: [$discipline] }
          visible: { eq: true }
        }
      }
    ) {
      totalCount
      edges {
        node {
          fields {
            slug
          }
          frontmatter {
            visible
            title
            disciplines
            cover {
              childImageSharp {
                sizes(maxWidth: 1400, cropFocus: CENTER) {
                  ...GatsbyImageSharpSizes_tracedSVG
                }
              }
            }
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/templates/discipline.js